import { Icon } from '@scality/core-ui';
import { Button } from '@scality/core-ui/dist/next';
import { useChat } from '../../hooks/useChat';

const RetryMessage: React.FC = () => {
  const { retryLastMessage } = useChat();

  return <Button icon={<Icon name="Sync" />} tooltip={{ overlay: 'Retry' }} onClick={retryLastMessage} />;
};

export default RetryMessage;
